/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Applications_TitleInputs */

const en_job_form_applications_title = /** @type {(inputs: Job_Form_Applications_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applications`)
};

const de_job_form_applications_title = /** @type {(inputs: Job_Form_Applications_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewerbungen`)
};

/**
* | output |
* | --- |
* | "Applications" |
*
* @param {Job_Form_Applications_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const job_form_applications_title = /** @type {((inputs?: Job_Form_Applications_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Applications_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_applications_title(inputs)
	return en_job_form_applications_title(inputs)
});